






































import { Vue, Component, Prop } from 'vue-property-decorator'
import { date } from 'quasar'
import store from 'src/assets/store'
import confirm from 'components/modals/Confirm'
import api from 'src/assets/api/gql'
import SessionUpdate from 'src/graphql/session/SessionUpdate.gql'
import { Session } from 'src/graphql/types'

@Component
export default class SessionListItem extends Vue {
  loading = false

  @Prop()
  readonly item!: Session

  @Prop()
  readonly isCourse!: boolean

  get me () {
    return store.state.person
  }

  formatDate (datetime: string) {
    return date.formatDate(new Date(datetime), 'dddd D MMM \'YY, HH:mm')
  }

  async trash (session: Session) {
    await confirm({
      title: this.$t('label.deleteConfirm').toString(),
      message: session.startedAt ? this.formatDate(session.startedAt) : '',
      btnRight: this.$t('label.delete').toString(),
      btnRightColor: 'warning'
    })
    this.loading = true
    await api.mutate({
      query: SessionUpdate,
      variables: {
        id: session.id,
        data: { deletedAt: (new Date()).toJSON() }
      }
    })
    this.loading = false
    this.$emit('remove')
  }
}
